import StyledLocalLink from "features/shared/components/link/styles/StyledLocalLink.styled";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import styled from "styled-components";

import AddressCard from "./AddressCard.styled";

const StyledAddressForm = styled.div`
  padding: 24px 0;

  ${AddressCard} {
    margin-top: 24px;
  }

  ${StyledLocalLink} {
    margin-bottom: 24px;
  }

  ${TertiaryHeader} {
    margin-bottom: 8px;
  }
`;

export default StyledAddressForm;
